import React, { useEffect } from "react";
import { useState } from "react";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import axios from "axios";

type LogType = {
  time: string;
  message: string;
}[];

const Energia = () => {
  const [dataInicial, setDataInicial] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [dataFinal, setDataFinal] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [totalGerado, setTotalGerado] = useState(0);
  const [geracaoDia, setGeracaoDia] = useState(0);
  const [totalInjetado, setTotalInjetado] = useState(0);
  const [totalImportado, setTotalImportado] = useState(0);
  const [irradianciaAtual, setIrradianciaAtual] = useState(0);
  const [potenciaAtual, setPotenciaAtual] = useState(0);
  useEffect(() => {
    searchData();
  }, []);

  const searchData = () => {
    axios
      .get("https://apisupervisorio.pvoperation.com/dados-geracao", {
        params: {
          dataInicial,
          dataFinal,
        },
      })
      .then((response) => {
        setChartData(response.data.chartData);
        setTotalGerado(response.data.etotal);
        setGeracaoDia(response.data.eday);
        setTotalInjetado(response.data.injetado);
        setTotalImportado(response.data.importado);
        setIrradianciaAtual(response.data.ir);
        setPotenciaAtual(response.data.pac);
      })
      .catch((error) => console.error("Erro ao buscar dados:", error));
  };

  // Estado para os dados do gráfico
  const [chartData, setChartData] = useState({
    labels: [
      "31/12",
      "01/01",
      "02/01",
      "03/01",
      "04/01",
      "05/01",
      "06/01",
      "07/01",
    ],
    datasets: [
      {
        label: "Energia (kWh)",
        data: [25000, 26000, 27000, 28000, 29000, 30000, 31000, 32000],
        backgroundColor: "green",
      },
    ],
  });

  // Estado para os registros recentes
  const [logs, setLogs] = useState<LogType>([]);

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        backgroundColor: "#f8f9fa",
      }}
    >
      {/* Título */}
      <h1>Dashboard de Geração de Energia</h1>

      {/* Indicadores */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "20px 0",
        }}
      >
        {[
          { label: "Total Gerado", value: totalGerado + " kWh" },
          { label: "Geração do Dia", value: geracaoDia + " kWh" },
          { label: "Total Injetado", value: totalInjetado + " kWh" },
          { label: "Total Importado", value: totalImportado + " kWh" },
          { label: "Irradiância Atual", value: irradianciaAtual + " W/m²" },
          { label: "Potência Atual", value: potenciaAtual + " W" },
        ].map((item, index) => (
          <div
            key={index}
            style={{
              padding: "10px 20px",
              backgroundColor: "#fff",
              border: "1px solid #ddd",
              borderRadius: "8px",
              flex: "1",
              margin: "0 10px",
              textAlign: "center",
            }}
          >
            <h4>{item.label}</h4>
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>{item.value}</p>
          </div>
        ))}
      </div>

      {/* Formulário para datas */}
      <div
        style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}
      >
        <input
          type="date"
          placeholder="Data Inicial (AAAA-MM-DD)"
          style={{
            padding: "10px",
            marginRight: "10px",
            borderRadius: "5px",
            border: "1px solid #ddd",
          }}
          value={dataInicial}
          onChange={(e) => setDataInicial(e.target.value)}
        />
        <input
          type="date"
          placeholder="Data Final (AAAA-MM-DD)"
          style={{
            padding: "10px",
            marginRight: "10px",
            borderRadius: "5px",
            border: "1px solid #ddd",
          }}
          value={dataFinal}
          onChange={(e) => setDataFinal(e.target.value)}
        />
        <button
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
          }}
          onClick={() => searchData()}
        >
          Atualizar Gráfico
        </button>
      </div>

      {/* Gráfico */}
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "20px",
        }}
      >
        <Bar data={chartData} />
      </div>

      {/* Tabela de logs */}
      <div
        style={{
          marginTop: "20px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
        }}
      >
        <h3 style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
          Últimos 20 Registros
        </h3>
        <ul
          style={{
            listStyle: "none",
            padding: "10px",
            maxHeight: "18rem",
            overflowY: "auto",
          }}
        >
          {logs.map((log, index) => (
            <li
              key={index}
              style={{ padding: "5px 0", borderBottom: "1px solid #f1f1f1" }}
            >
              <span style={{ fontWeight: "bold" }}>{log.time} - </span>
              {log.message}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Energia;
